// extracted by mini-css-extract-plugin
module.exports = {"coButton":"CoLoginBannerLarge_coButton__GL8aS"};